module.exports = __webpack_public_path__ + "static/img/index8.e7b3d5e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index8.gif
// module id = Dg+3
// module chunks = 0